/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetEventTeam,
  FleetEventTeamCreateInput,
  FleetEventTeamUpdateInput,
  SchemaValidationErrorResponse,
  SortInput,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create event team
 */
export const createFleetEventTeam = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    fleetEventTeamCreateInput: MaybeRefOrGetter<FleetEventTeamCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
fleetEventTeamCreateInput = toValue(fleetEventTeamCreateInput);

      return axiosClient<FleetEventTeam>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventTeamCreateInput, signal
    },
      );
    }




export const getCreateFleetEventTeamMutationKey = () => ['createFleetEventTeam'] as const;

export const getCreateFleetEventTeamMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventTeam>>, TError,CreateFleetEventTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEventTeam>>, TError,CreateFleetEventTeamMutationVariables, TContext> => {

const mutationKey = getCreateFleetEventTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEventTeam>>, CreateFleetEventTeamMutationVariables> = (props) => {
          const {fleetSlug,fleetEventSlug,data} = props ?? {};

          return  createFleetEventTeam(fleetSlug,fleetEventSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEventTeam>>>
    export type CreateFleetEventTeamMutationBody = FleetEventTeamCreateInput
    export type CreateFleetEventTeamMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetEventTeamMutationVariables = {fleetSlug: string;fleetEventSlug: string;data: FleetEventTeamCreateInput}

    /**
 * @summary Create event team
 */
export const useCreateFleetEventTeam = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEventTeam>>, TError,CreateFleetEventTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEventTeam>>,
        TError,
        CreateFleetEventTeamMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetEventTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort event teams
 */
export const sortFleetEventTeams = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    sortInput: MaybeRefOrGetter<SortInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
sortInput = toValue(sortInput);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sortInput, signal
    },
      );
    }




export const getSortFleetEventTeamsMutationKey = () => ['sortFleetEventTeams'] as const;

export const getSortFleetEventTeamsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventTeams>>, TError,SortFleetEventTeamsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventTeams>>, TError,SortFleetEventTeamsMutationVariables, TContext> => {

const mutationKey = getSortFleetEventTeamsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortFleetEventTeams>>, SortFleetEventTeamsMutationVariables> = (props) => {
          const {fleetSlug,fleetEventSlug,data} = props ?? {};

          return  sortFleetEventTeams(fleetSlug,fleetEventSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortFleetEventTeamsMutationResult = NonNullable<Awaited<ReturnType<typeof sortFleetEventTeams>>>
    export type SortFleetEventTeamsMutationBody = SortInput
    export type SortFleetEventTeamsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SortFleetEventTeamsMutationVariables = {fleetSlug: string;fleetEventSlug: string;data: SortInput}

    /**
 * @summary Sort event teams
 */
export const useSortFleetEventTeams = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortFleetEventTeams>>, TError,SortFleetEventTeamsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortFleetEventTeams>>,
        TError,
        SortFleetEventTeamsMutationVariables,
        TContext
      > => {
      return useMutation(getSortFleetEventTeamsMutationOptions(options), queryClient);
    }
    /**
 * @summary Update event team
 */
export const updateFleetEventTeam = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    fleetEventTeamUpdateInput: MaybeRefOrGetter<FleetEventTeamUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
id = toValue(id);
fleetEventTeamUpdateInput = toValue(fleetEventTeamUpdateInput);

      return axiosClient<FleetEventTeam>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventTeamUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventTeamMutationKey = () => ['updateFleetEventTeam'] as const;

export const getUpdateFleetEventTeamMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventTeam>>, TError,UpdateFleetEventTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventTeam>>, TError,UpdateFleetEventTeamMutationVariables, TContext> => {

const mutationKey = getUpdateFleetEventTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventTeam>>, UpdateFleetEventTeamMutationVariables> = (props) => {
          const {fleetSlug,fleetEventSlug,id,data} = props ?? {};

          return  updateFleetEventTeam(fleetSlug,fleetEventSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventTeam>>>
    export type UpdateFleetEventTeamMutationBody = FleetEventTeamUpdateInput
    export type UpdateFleetEventTeamMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetEventTeamMutationVariables = {fleetSlug: string;fleetEventSlug: string;id: string;data: FleetEventTeamUpdateInput}

    /**
 * @summary Update event team
 */
export const useUpdateFleetEventTeam = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventTeam>>, TError,UpdateFleetEventTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventTeam>>,
        TError,
        UpdateFleetEventTeamMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetEventTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy event team
 */
export const destroyFleetEventTeam = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventSlug = toValue(fleetEventSlug);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/events/${fleetEventSlug}/teams/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventTeamMutationKey = () => ['destroyFleetEventTeam'] as const;

export const getDestroyFleetEventTeamMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventTeam>>, TError,DestroyFleetEventTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventTeam>>, TError,DestroyFleetEventTeamMutationVariables, TContext> => {

const mutationKey = getDestroyFleetEventTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEventTeam>>, DestroyFleetEventTeamMutationVariables> = (props) => {
          const {fleetSlug,fleetEventSlug,id} = props ?? {};

          return  destroyFleetEventTeam(fleetSlug,fleetEventSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventTeamMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEventTeam>>>

    export type DestroyFleetEventTeamMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetEventTeamMutationVariables = {fleetSlug: string;fleetEventSlug: string;id: string}

    /**
 * @summary Destroy event team
 */
export const useDestroyFleetEventTeam = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventTeam>>, TError,DestroyFleetEventTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEventTeam>>,
        TError,
        DestroyFleetEventTeamMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetEventTeamMutationOptions(options), queryClient);
    }
